import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserPreferences {
  soundEnabled: boolean;
  autoplay: boolean;
  savedSections: string[];
}

const initialState: UserPreferences = {
  soundEnabled: true,
  autoplay: true,
  savedSections: [],
};

const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    toggleSound: (state) => {
      state.soundEnabled = !state.soundEnabled;
    },
    toggleAutoplay: (state) => {
      state.autoplay = !state.autoplay;
    },
    addSavedSection: (state, action: PayloadAction<string>) => {
      if (!state.savedSections.includes(action.payload)) {
        state.savedSections.push(action.payload);
      }
    },
    removeSavedSection: (state, action: PayloadAction<string>) => {
      state.savedSections = state.savedSections.filter(
        (section) => section !== action.payload
      );
    },
  },
});

export const {
  toggleSound,
  toggleAutoplay,
  addSavedSection,
  removeSavedSection,
} = userPreferencesSlice.actions;

export default userPreferencesSlice.reducer; 